'use strict';
var analysisTemplateModalTpl = require('./template-modal.html');
var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$scope", "AuthenticationFactory", "UrlRoutingFactory", "$uibModal", "ProjectService", "MessageDataRepository", "ChartService", "MessageDataStructureStorage", "GraphStackingStorage", "ConfigurationStoreService", function ($scope, AuthenticationFactory, UrlRoutingFactory, $uibModal, ProjectService, MessageDataRepository, ChartService, MessageDataStructureStorage, GraphStackingStorage, ConfigurationStoreService) {
    "use strict";
    var te = this;
    te.parent = $scope.$parent.ch;

    var templateId = UrlRoutingFactory.get("templateId");
    var templateConfigName = UrlRoutingFactory.get("templateConfigName");
    te.templates = [];
    te.template = {};
    te.viewStructure = te.parent.viewStructure;
    te.messageStructure = te.parent.messageStructure;
    te.stack = te.parent.stack;
    te.chartTemplateConfigurations = [];

    var init = function () {
        findAllTemplates(true);
        findAllConfigTemplates();
    };

    /**
     * Template test functions
     */

    te.canSaveTemplate = function () {
        return te.isUsersTemplate();
    };

    te.isUsersTemplate = function () {
        if (!util.isDefined(te.template)) {
            return false;
        }
        var currentUser = AuthenticationFactory.getUser();
        return currentUser.name == te.template.userName;
    };

    /**
     * Current template functionality
     */
    te.saveCurrentTemplate = function () {
        if (te.template.name != "") {
            saveTemplate();
        } else {
            askForSaveName();
        }
    };

    te.quitCurrentTemplate = function () {
        removeTraceOfTemplate();
    };

    te.deleteCurrentTemplate = function () {
        var currentUser = AuthenticationFactory.getUser();
        if (te.template.userName == currentUser.name) {
            if (confirm('Are you sure you want to delete template ' + te.template.name + '?')) {
                ChartService.template().remove({
                    id: te.template.id,
                    projectId: ProjectService.getSelectedProjectId()
                }).$promise.then(function () {
                        removeTraceOfTemplate();
                        findAllTemplates(true);
                    });
            }
        }
    };

    te.reloadCurrentTemplate = function () {
        "use strict";
        applyCurrentTemplateToChart();
    };


    te.saveAsCurrentTemplate = function () {
        askForSaveName();
    };

    te.templateChoose = function (index) {
        selectTemplate(te.templates[index]);
        applyCurrentTemplateToChart();
    };

    te.chooseConfigTemplate = function (index) {
        selectTemplate(te.chartTemplateConfigurations[index]);
        applyCurrentTemplateToChart();
    };

    function removeTraceOfTemplate() {
        "use strict";
        clearTemplate();
        clearChart();
    }

    function clearChart() {
        "use strict";
        var messageNames = te.messageStructure.getMessageNamesWithSelectedProperties();
        messageNames.forEach(function (messageName) {
            te.viewStructure.resetProperties(messageName);
            te.messageStructure.resetProperties(messageName);
        });
        te.parent.cleanupChart();
    }


    function askForSaveName() {
        var saveName = $uibModal.open({
            template: analysisTemplateModalTpl,
            controller: "TemplateModalController",
            size: 'sm',
            resolve: {
                chosenName: function () {
                    return te.template.name;
                },
                templates: ["AuthenticationFactory", function (AuthenticationFactory) {
                    var templates = [];
                    te.templates.forEach(function (entry) {
                        if (entry.userName === AuthenticationFactory.getUser().name) {
                            templates.push(entry);
                        }
                    });
                    return templates;
                }]
            }
        });

        saveName.result.then(function (data) {
            if (data.id !== 0) {
                te.template.id = data.id;
            } else if (util.isDefined(te.template.id)) {
                delete te.template.id;
            }

            te.template = {
                name: data.name,
                userName: AuthenticationFactory.getUser().name,
                timestamp: new Date(),
                projectId: ProjectService.getSelectedProjectId(),
                strict: !te.parent.dataGrouping
            };

            saveTemplate();
        }, function () {
        });
    }


    function saveTemplate() {
        var object = te.template;
        object.configuration = JSON.stringify(te.messageStructure.getTemplate());
        te.stack = te.parent.stack;
        object.stack = te.stack;
        object.stacking = JSON.stringify(GraphStackingStorage.get('chart'));
        ChartService.templates().save({projectId: ProjectService.getSelectedProjectId()}, object).$promise.then(function (data) {
            selectTemplate(data);
            findAllTemplates(false);
        });
    }


    function findAllTemplates(load) {
        ChartService.templatesForUser().query({
            projectId: ProjectService.getSelectedProjectId(),
            userId: AuthenticationFactory.getUser().id
        }).$promise.then(function (response) {
                te.templates = response;
                //todo fix template when loading for an other train.
                if (util.isDefined(templateId) && load) {
                    var storedMessageDataStructure = MessageDataStructureStorage.get('chart');
                    if (!util.isDefined(storedMessageDataStructure)) {
                        for (var i = 0; i < te.templates.length; i++) {
                            if (te.templates[i].id == templateId) {
                                te.templateChoose(i);
                            }
                        }
                    }
                }
            }, function (httpResponse) {
                console.error(httpResponse.data.errorMessage);
            });
    }

    function findAllConfigTemplates(){
        var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());
        var trainDetailConfiguration = projectConfiguration && projectConfiguration["trainDetailConfiguration"];
        if(util.isDefined(trainDetailConfiguration) && util.isDefined(templateConfigName)){
            te.chartTemplateConfigurations = trainDetailConfiguration["chartTemplateConfigurations"];
            for (var i = 0; i < te.chartTemplateConfigurations.length; i++) {
                if (te.chartTemplateConfigurations[i].name === templateConfigName) {
                    te.chooseConfigTemplate(i);
                }
            }
        }
    }

    function selectTemplate(template) {
        "use strict";
        te.template = template;
        if(util.isDefined(te.template.id)){
            UrlRoutingFactory.save('templateId', te.template.id);
            templateId = te.template.id;
        }
        if (util.isDefined(templateConfigName)){
            UrlRoutingFactory.save('templateConfigName',templateConfigName);
        }

    }

    function clearTemplate() {
        "use strict";
        te.template = {};
        if (util.isDefined(templateId)) {
            UrlRoutingFactory.delete('templateId');
        }
        if (util.isDefined(templateConfigName)){
            UrlRoutingFactory.delete('templateConfigName');
        }
        templateId = undefined;
    }

    function applyCurrentTemplateToChart() {
        "use strict";
        clearChart();
        te.parent.useDataGrouping(!te.template.strict);
        te.messageStructure.setTemplate(JSON.parse(te.template.configuration));
        te.viewStructure.setTemplate(JSON.parse(te.template.configuration));
        var messageNames = te.messageStructure.getMessageNamesWithSelectedProperties();
        var fetchFunction = MessageDataRepository.getMessageData;
        var replace = true;
        var useCache = false;
        te.parent.isLoading = true;
        te.parent.stack = te.template.stack;
        if (util.isDefined(te.template.stacking)) {
            GraphStackingStorage.save('chart', JSON.parse(te.template.stacking));
        }

        te.parent.putMessagesOnChart(messageNames, fetchFunction, replace, useCache).then(function () {
            if (util.isDefined(te.template.stacking)) {
                te.parent.applyStackingList(GraphStackingStorage.get('chart'));
            } else {
                te.parent.applyFullStacking();
            }
        });
    }

    init();
}];
